export default "__VITE_PUBLIC_ASSET__95313433__"